import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { EntryPointRouteParams } from '@atlassian/jira-entry-points-plugin/src/common/types.tsx';
import parameters from '@atlassian/jira-relay/src/__generated__/ListQuery$parameters';

export const listEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-list", jiraSpaEntry: "async-servicedesk-list" */ './src/ui/List.tsx'
			),
	),
	getPreloadProps: ({ context: { match }, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const boardId = match.params.boardId;
		const boardAri = `ari:cloud:jira-software:${cloudId}:board/${boardId}`;
		const projectKey = match.params.projectKey ?? '';

		const issueSearchInput = {
			customInput: {
				jiraSoftwareInput: {
					jiraEntityId: boardAri,
					additionalJql: '',
				},
			},
		};

		const defaultProps = {
			first: 50,
			last: null,
			before: null,
			after: null,
			options: { issueKey: null },
			viewConfigInput: {
				staticViewInput: {
					isHierarchyEnabled: false,
					isGroupingEnabled: false,
					isHideDoneEnabled: false,
				},
			},
			filterId: null,
			namespace: 'JSM_ISSUE_NAVIGATOR',
			amountOfColumns: 500,
			groupBy: null,
			viewQueryInput: null,
			shouldQueryHasChildren: false,
			fieldSetsInput: {
				viewInput: {
					namespace: 'JSM_ISSUE_NAVIGATOR',
					filterId: null,
				},
			},
			scope: {
				operationScope: 'NIN_PROJECT' as const,
				projectKey,
			},
			fieldSetsScope: {
				operationScope: 'NIN_PROJECT' as const,
				projectKey,
			},
			boardId: boardAri,
		};

		return {
			queries: {
				jsmListDataQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						issueSearchInput,
						projectKey,
						...defaultProps,
					},
				},
			},
			extraProps: {
				cloudId,
				projectKey,
				issueSearchInput,
				defaultProps,
			},
		};
	},
});
